import {
  useQuery,
  useQueryClient,
  UseQueryOptions,
} from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { ApplicationData, ApplicationsData } from "./types";
import { applicationsKeys } from "./utils";

/**
 * Fetch a single application
 * @param applicationId application id
 * @param options useQuery options
 * @returns useQuery result
 */
export const useApplication = <TData extends {} = ApplicationData>(
  applicationId: string,
  options?: UseQueryOptions<ApplicationData, PortalAxiosError, TData>
) => {
  const server = useServer();
  const queryClient = useQueryClient();

  return useQuery<ApplicationData, PortalAxiosError, TData>(
    applicationsKeys.getOne(applicationId),
    () => server.get(`applications/${applicationId}`),
    {
      placeholderData: () => {
        const applicationsData = queryClient.getQueryData<ApplicationsData>(
          applicationsKeys.list()
        );
        const application = applicationsData?.data.find((application) => {
          return application.id === applicationId;
        });

        return application ? { data: application } : undefined;
      },
      staleTime: 1 * 60 * 1000,
      ...options,
    }
  );
};

export default useApplication;
